import React, { Component } from "react";
import { connect } from 'react-redux';
import { activateWebsite } from '../Claim/activatewebsite';
import "../../assets/css/dashboard.css";
import apiInstance from "../apiInstance";
import PopupModal from "./popups/PopupModal";
import withRouter from "../../utility/withRouter";

class Emails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            websites: [],
            currentWebsite: "",
            skeletonLoading: true,
            emails: [],
            emailsLimit: 1,
            error: "",
            loading: false,
            currentEmail: ''
        };
        this.popupRef = React.createRef();
    }

    async componentDidMount() {
        await apiInstance
            .get("/dashboard/websites")
            .then( async (response) => {
                this.setState({ error: "" });
                const websites = response.data.websites;
                let currentWebsite = null;

                const storedWebsiteId = localStorage.getItem('currentWebsiteId');
                if(storedWebsiteId) {
                    currentWebsite = websites.find(item => item._id === storedWebsiteId);
                }

                if(!currentWebsite && websites.length > 0) {
                    currentWebsite = websites[0];
                }

                this.setState(() => {
                    return {
                        websites: websites,
                        currentWebsite: currentWebsite,
                    };
                });

                if (currentWebsite) {
                    localStorage.setItem('currentWebsiteId', currentWebsite._id);
                    await apiInstance
                        .get(`/dashboard/emails/${currentWebsite._id}`)
                        .then((response) => {
                            this.setState({ error: "" });
                            const emails = response.data.emails.emails;
                            const emailsLimit = response.data.emails.allowedCount;

                            this.setState(() => {
                                return {
                                    emails: emails,
                                    emailsLimit: emailsLimit
                                };
                            });
                        })
                        .catch((error) => {
                            console.error("Error fetching data:", error);
                            this.setState({ error: error.response?.data?.message || "Failed to load emails" });
                        });
                }
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                this.setState({ error: error.response?.data?.message || "Failed to load websites" });
            });
        this.setState({skeletonLoading: false});
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleCurrentSiteChange = async (e) => {
        this.setState({skeletonLoading: true});

        const selectedSite = e.target.value;
        let siteIndex = 0;
        this.state.websites.map((website, index) =>
            website.siteName === selectedSite ? (siteIndex = index) : ""
        );
        const currentsite = this.state.websites[siteIndex];
        this.setState({ currentWebsite: currentsite });
        
        if(currentsite) {
            localStorage.setItem('currentWebsiteId', currentsite._id);
        } else {
            localStorage.removeItem('currentWebsiteId');
        }

        await apiInstance
            .get(`/dashboard/emails/${currentsite._id}`)
            .then((response) => {
                this.setState({ error: "" });
                const emails = response.data.emails.emails;
                const emailsLimit = response.data.emails.allowedCount;

                this.setState(() => {
                    return {
                        emails: emails,
                        emailsLimit: emailsLimit
                    };
                });
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                this.setState({ error: error.response?.data?.message || "Something went wrong, please try again later." });
            });
        this.setState({skeletonLoading: false});
    };

    getWebmailSession = async (email) => {

        this.setState({loading: true});
        this.setState({currentEmail: email});
        
        apiInstance
            .get(`/dashboard/emails/login/${email}`)
            .then((response) => {
                this.setState({ error: "" });
                const loginUrl = response.data.loginUrl;
                const session = response.data.session;

                if (session) {
                    const form = document.createElement("form");
                    form.method = "POST";
                    form.action = loginUrl;
                    form.target = "_blank";

                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = "session";
                    input.value = session;

                    form.appendChild(input);
                    document.body.appendChild(form);
                    form.submit();
                    document.body.removeChild(form);
                }
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                this.setState({ error: error.response?.data?.message || "Something went wrong, please try again later." });
            })
            .finally(() => {
                this.setState({loading: false});
                this.setState({currentEmail: ''});
            });
    };

    getStoragePercentage = (used, quota) => {
        if (!quota || quota <= 0) return 0;
        return Math.min((used / quota) * 100, 100);
    };

    getStorageColor = (percent) => {
        if (percent >= 90) return "#e74c3c";   
        if (percent >= 70) return "#f39c12";   
        return "#4caf50";                      
    };

    activateNow = async (siteId) => {
        try {
            await activateWebsite({
                siteId,
                userEmail: this.props.user?.email
            });
        } catch (err) {
            console.error('Checkout failed:', err.message);
            this.setState({ error: err.message || "Request failed. Please contact us." });
        }
    }

    render() {
        const emails = Array.isArray(this.state.emails)
            ? this.state.emails
            : [];
        const websites = Array.isArray(this.state.websites)
            ? this.state.websites
            : [];
        
        const currSiteId = this.state.currentWebsite?._id;
        const currSiteCodeName = this.state.currentWebsite?.siteName;
        const currSiteUrl = this.state.currentWebsite?.siteUrl;
        const cleanCurrSiteUrl = currSiteUrl?.replace(/^https?:\/\//, "");
        const mainDomain = process.env.REACT_APP_MAIN_DOMAIN;
        const isTestSite = this.state.currentWebsite?.siteUrl?.includes(mainDomain);
        const currentWebsite = this.state.currentWebsite;
        const emailsLimit = this.state.emailsLimit;
        const skeletonLoading = this.state.skeletonLoading;
        const error = this.state.error;

        const currSiteSubscriptionStatus = this.state.currentWebsite?.subscription?.status || '-';

        return (
            <>
                {websites?.length > 0 &&
                    <div className="mjs-dash-top">
                        <div className="mjs-dash-top-site-dd">
                            <span>Active Website </span>
                            <select
                                className="mjs-select"
                                value={currSiteCodeName}
                                onChange={this.handleCurrentSiteChange}
                            >
                                {websites.map((website, index) => (
                                    <option
                                        key={website._id}
                                        value={website.siteName}
                                    >
                                        {website.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                }

                <div className="mjs-dash-section">
                    <h4>Email Management</h4>

                    {websites?.length > 0 ?
                    <>
                        {
                        skeletonLoading !== false ? 
                            <div className='mjs_pre_skeleton_text mjs-width-20'></div>
                        :
                        currSiteSubscriptionStatus !== 'active' ?
                            <p className="mjs-m-0">Set up and manage your business email accounts</p>
                        :
                        emails?.length > 0 ? (
                            <div className="mjs-m-0 mjs-row">
                                Manage your business email accounts
                                <div className="mjs-m-0 mjs-row">
                                    <span
                                        className="mjs-btn mjs-mr-10"
                                        onClick={() => {
                                            if (this.popupRef.current) {
                                                this.popupRef.current.openPopup(
                                                    "addEmail",
                                                    {
                                                        currSiteUrl: this.state.currentWebsite?.siteUrl,
                                                        currSiteId: this.state.currentWebsite?._id
                                                    }
                                                );
                                            }
                                        }}
                                    >
                                        Add New Email
                                    </span>

                                    <span
                                        className="mjs-btn"
                                        onClick={() => {
                                            if (this.popupRef.current) {
                                                this.popupRef.current.openPopup(
                                                    "mailClientSettings",
                                                    {
                                                        cleanCurrSiteUrl
                                                    }
                                                );
                                            }
                                        }}
                                    >
                                        Email App Settings
                                    </span>
                                </div>
                            </div>
                            )
                            :
                            (
                                <p className="mjs-m-0">Set up and manage your business email accounts</p>
                            )
                        }

                        {error && <div className="mjs_text_error">{error}</div>}

                        <div className="mjs-dash-sec-card">
                            {
                            skeletonLoading !== false ? 
                                <>
                                    <div className='mjs_pre_skeleton_text mjs-width-10'></div>
                                    <div className='mjs_pre_skeleton_text mjs-width-20'></div>
                                    <div className='mjs_pre_skeleton_text mjs-width-15'></div>
                                    <div className='mjs_pre_skeleton_text mjs-width-25'></div>
                                </>
                            :
                            currSiteSubscriptionStatus !== 'active' ?
                            <div>
                                <p className="mjs_text_error">
                                    <span className="mjs-mr-5">Email Management Locked. Activate your website to enable professional email accounts.</span>
                                    <span className="mjs-ml-5 mjs-quick-action-link" onClick={() => this.activateNow(currSiteId)}>Activate Now</span>
                                </p>
                            </div>
                            :
                            emails?.length > 0 ? (
                                <>
                                    <table className="mjs-table mjs-no-border-pdng">
                                        <thead>
                                            <tr>
                                                <th className="mjs-width-30">Account @ Domain</th>
                                                <th className="mjs-width-20">Storage Usage</th>
                                                <th className="mjs-text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {emails.map((email) => {
                                                const used = email.storageUsed || 0;
                                                const quota = email.storageQuota || 0;
                                                const percentage = this.getStoragePercentage(used, quota);

                                                return (
                                                    <tr key={email.address}>
                                                        <td className="mjs-i-action mjs-link">
                                                            <i className="fa-sharp fa-solid fa-envelope"></i> 
                                                            <span onClick={() => this.getWebmailSession(email.address) }>{email.address}</span>
                                                            {
                                                                this.state.loading && this.state.currentEmail === email.address && (
                                                                    <i className="fa-solid fa-spinner fa-spin"></i>
                                                                )
                                                            }
                                                            {/* <p>
                                                                <span
                                                                    className="mjs-i-action mjs-link"
                                                                    onClick={() =>
                                                                        this.getWebmailSession(email.address)
                                                                    }
                                                                >
                                                                <i className="fa-sharp fa-solid fa-envelope"></i>Open Webmail <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                                                </span>
                                                            </p> */}
                                                        </td>

                                                        <td className="mjs-progress-wrapper">
                                                            <div>
                                                                {used} MB / {quota} MB ({percentage.toFixed(1)}%)
                                                            </div>

                                                            <div className="mjs-progress-bar">
                                                                <div
                                                                    className="mjs-progress-bar-fill"
                                                                    style={{
                                                                        width: `${percentage}%`,
                                                                        backgroundColor: this.getStorageColor(percentage),
                                                                    }}
                                                                />
                                                            </div>
                                                        </td>

                                                        <td className="mjs-text-center">

                                                            <span
                                                                className="mjs-btn mjs-btn-primary mjs-mr-10"
                                                                onClick={() =>
                                                                    this.getWebmailSession(email.address)
                                                                }
                                                            >
                                                                Open Webmail
                                                            </span>

                                                            <span
                                                                className="mjs-btn mjs-mr-10"
                                                                onClick={() => {
                                                                    if (this.popupRef.current) {
                                                                        this.popupRef.current.openPopup(
                                                                            "changeEmailPassword",
                                                                            {
                                                                                websiteId: currentWebsite._id,
                                                                                email: email.address,
                                                                                domain: cleanCurrSiteUrl
                                                                            }
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                Reset Password
                                                            </span>

                                                            <span
                                                                className="mjs-btn mjs_text_error"
                                                                onClick={() => {
                                                                    if (this.popupRef.current) {
                                                                        this.popupRef.current.openPopup(
                                                                            "deleteEmail",
                                                                            {
                                                                                websiteId: currentWebsite._id,
                                                                                email: email.address,
                                                                            }
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                Delete
                                                            </span>

                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>

                                    </table>

                                    {
                                        emailsLimit && 
                                        <p className="mjs_text_grey">You can create up to {emailsLimit} professional email {emailsLimit === 1 ? "account" : "accounts"}. Get Email addon if you want to add more email accounts.</p>
                                    }

                                </>
                            ) : (
                                <div>
                                    {currentWebsite && !isTestSite ? (
                                        <>
                                            <h4><i className="fa-sharp fa-solid fa-envelope"></i> No Business Emails Yet</h4>
                                            <p>Create a professional email address for your website.</p>
                                            <span
                                                className="mjs-btn mjs-btn-primary"
                                                onClick={() => {
                                                    if (this.popupRef.current) {
                                                        this.popupRef.current.openPopup(
                                                            "addEmail",
                                                            {
                                                                currSiteUrl: this.state.currentWebsite?.siteUrl,
                                                                currSiteId: this.state.currentWebsite?._id
                                                            }
                                                        );
                                                    }
                                                }}
                                            >
                                                Add New Email
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            <h4><i class="fa-solid fa-globe mjs_text_grey"></i> Domain Not Connected</h4>
                                            <p>Please connect a domain before creating a professional email addresses for your website.</p>
                                            <span
                                                className="mjs-btn mjs-btn-primary"
                                                onClick={() => this.props.navigate("/domains")}
                                            >
                                                Connect Domain
                                            </span>
                                        </>
                                    )}
                                </div>
                            )
                        }
                        </div>
                    </>
                    :
                    <>
                        {skeletonLoading !== false ? 
                            <div className='mjs_pre_skeleton_text mjs-width-20'></div>
                        :
                            <p className='mjs_text_error'>You don't have any website yet!.</p>
                        }
                    </>
                    }
                </div>
                <PopupModal
                    ref={this.popupRef}
                    updateEmails={(emails, emailsLimit) => {
                        this.setState(() => {
                            return {
                                emails: emails,
                                emailsLimit: emailsLimit
                            };
                        });
                    }}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return (
        {
            user: state.currentUser,
        }
    )
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(withRouter(Emails));
